"use client";

import { useLingui } from "@lingui/react/macro";
import { Button, FormInput } from "@offstreetparking/design-system/forms";
import { Link, Text } from "@offstreetparking/design-system/typography";
import { Form } from "@offstreetparking/portal-flow/components/forms/Form";
import { ButtonRow } from "@offstreetparking/portal-flow/components/layouts/ButtonRow";
import { useSupportUrl } from "@offstreetparking/portal-flow/hooks/useSupportUrl";
import { useRouter } from "next/navigation";
import { useId } from "react";
import { useZod } from "~/components/providers/TranslationsProvider";
import { routes } from "~/routes";
import { offstreetClient } from "~/services/offstreetApi";
export const dynamic = "force-dynamic";
export const fetchCache = "default-no-store";
export default function SessionLookupPage() {
	const z = useZod();
	const { t } = useLingui();
	const formId = useId();
	const { mutate: lookupPermit, error, isPending } = offstreetClient.permit.permitLookup.useMutation();
	const router = useRouter();
	const { supportUrl } = useSupportUrl({ ticketForm: "need_your_confirmation_receipt?" });
	return (
		<Form
			id={formId}
			className="space-y-4 p-8"
			schema={z.object({
				publicIdentifier: z.string().length(9),
			})}
			serverError={error}
			onSubmit={({ publicIdentifier }) => {
				lookupPermit(
					{
						publicIdentifier,
					},
					{
						onSuccess: (data) => {
							if ("permitId" in data && data.permitId) {
								router.push(
									routes.permitConfirmation({
										publicIdentifier,
									}),
								);
							}
							if ("registrationId" in data && data.registrationId) {
								router.push(
									routes.registrationConfirmation({
										publicIdentifier,
									}),
								);
							}
						},
					},
				);
			}}
		>
			<FormInput name="publicIdentifier" label={t`Confirmation Number`} />
			<div>
				<Text className="font-bold">{t`Can't find your confirmation number?`}</Text>
				<Text size="sm">
					<Link href={supportUrl} isExternal aria-label={`${t`Contact Us`} ${t`(opens in a new tab)`}`}>
						{t`Contact Us`}
					</Link>
				</Text>
			</div>
			<ButtonRow>
				<Button isLoading={isPending} type="submit" form={formId} className={"w-full text-base md:w-[160px]"}>
					{t`Lookup`}
				</Button>
			</ButtonRow>
		</Form>
	);
}
